import { axiosInstance } from '../Axios';
import {
	bannerDispatch,
	showBankDispatch,
	showCategoryDispatch,
	showPackageDispatch,
} from './HomeReducer';
const { createSlice } = require('@reduxjs/toolkit');

const GeneralReducer = createSlice({
	name: 'home',
	initialState: {
		success: false,
		error: null,
		loading: false,
		loginInfo: null,
		deleteBank: null,
		updateBanner: null,
		markup: null,
	},
	reducers: {
		loginRequest(state, action) {
			state.loading = true;
		},
		loginSuccess(state, action) {
			state.loading = false;
			state.loginInfo = action.payload;
			state.error = null;
		},
		loginFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		updateBannerRequest(state, action) {
			state.loading = true;
		},
		updateBannerSuccess(state, action) {
			state.loading = false;
			state.updateBanner = action.payload;
			state.error = null;
		},
		updateBannerFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		deleteBankRequest(state, action) {
			state.loading = true;
		},
		deleteBankSuccess(state, action) {
			state.loading = false;
			state.deleteBank = action.payload;
			state.error = null;
		},
		deleteBankFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		markupRequest(state, action) {
			state.loading = true;
		},
		markupSuccess(state, action) {
			state.loading = false;
			state.markup = action.payload;
			state.error = null;
		},
		markupFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
	},
});

const { actions } = GeneralReducer;
const config = {
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json',
	},
};
export const {
	updateBannerRequest,
	updateBannerSuccess,
	updateBannerFail,
	deleteBankRequest,
	deleteBankSuccess,
	deleteBankFail,
	markupRequest,
	markupSuccess,
	markupFail,
} = actions;

export const updateBannerDispatch =
	(bodyData, navigate, id, Swal, token) => async (dispatch) => {
		try {
			const config = {
				headers: {
					Accept: 'multipart/form-data',
					// Authorization: `Bearer ${token}`,
				},
			};
			dispatch(updateBannerRequest());
			const { data } = await axiosInstance.put(
				`/banners/${id}`,
				bodyData,
				config,
			);
			console.log('data', data);
			dispatch(updateBannerSuccess(data));
			if (data) {
				dispatch(bannerDispatch());
				// navigate('/bank/list');
				Swal.fire({
					title: 'Banner Updated Successfully!',
					icon: 'success',
					draggable: true,
				});
			}
		} catch (error) {
			console.log('error', error);
			dispatch(
				updateBannerFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message,
				),
			);
		}
	};
export const deleteBankDetailDispatch =
	(id, Swal, token) => async (dispatch) => {
		try {
			const config = {
				headers: {
					Accept: 'application/json',
					// Authorization: `Bearer ${token}`,
				},
			};
			dispatch(deleteBankRequest());
			const { data } = await axiosInstance.delete(`/company/${id}`, config);
			console.log('data', data);
			dispatch(deleteBankSuccess(data));
			if (data) {
				dispatch(showBankDispatch());
				// navigate('/bank/list');
				Swal.fire({
					title: 'Bank Detail Delete Successfully!',
					icon: 'success',
					draggable: true,
				});
			}
		} catch (error) {
			console.log('error', error);
			dispatch(
				deleteBankFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message,
				),
			);
		}
	};
export const deleteBannerDispatch = (id, Swal, token) => async (dispatch) => {
	try {
		const config = {
			headers: {
				Accept: 'application/json',
				// Authorization: `Bearer ${token}`,
			},
		};
		dispatch(deleteBankRequest());
		const { data } = await axiosInstance.delete(`/banners/${id}`, config);
		console.log('data', data);
		dispatch(deleteBankSuccess(data));
		if (data) {
			dispatch(bannerDispatch());
			// navigate('/bank/list');
			Swal.fire({
				title: 'Banner Delete Successfully!',
				icon: 'success',
				draggable: true,
			});
		}
	} catch (error) {
		console.log('error', error);
		dispatch(
			deleteBankFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message,
			),
		);
	}
};
export const updatePCDispatch =
	(bodyData, navigate, id, Swal, token) => async (dispatch) => {
		try {
			const config = {
				headers: {
					Accept: 'multipart/form-data',
					// Authorization: `Bearer ${token}`,
				},
			};
			dispatch(updateBannerRequest());
			const { data } = await axiosInstance.put(`/pc/${id}`, bodyData, config);
			console.log('data', data);
			dispatch(updateBannerSuccess(data));
			if (data) {
				dispatch(showCategoryDispatch());
				// navigate('/bank/list');
				Swal.fire({
					title: 'Package Category Updated Successfully!',
					icon: 'success',
					draggable: true,
				});
			}
		} catch (error) {
			console.log('error', error);
			dispatch(
				updateBannerFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message,
				),
			);
		}
	};
export const deletePCDispatch = (id, Swal, token) => async (dispatch) => {
	try {
		const config = {
			headers: {
				Accept: 'application/json',
				// Authorization: `Bearer ${token}`,
			},
		};
		dispatch(deleteBankRequest());
		const { data } = await axiosInstance.delete(`/pc/${id}`, config);
		console.log('data', data);
		dispatch(deleteBankSuccess(data));
		if (data) {
			dispatch(showCategoryDispatch());
			// navigate('/bank/list');
			Swal.fire({
				title: 'Package Category Delete Successfully!',
				icon: 'success',
				draggable: true,
			});
		}
	} catch (error) {
		console.log('error', error);
		dispatch(
			deleteBankFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message,
			),
		);
	}
};
export const updatePDispatch =
	(bodyData, navigate, id, Swal, token) => async (dispatch) => {
		try {
			const config = {
				headers: {
					Accept: 'multipart/form-data',
					// Authorization: `Bearer ${token}`,
				},
			};
			dispatch(updateBannerRequest());
			const { data } = await axiosInstance.put(
				`/package/${id}`,
				bodyData,
				config,
			);
			console.log('data', data);
			dispatch(updateBannerSuccess(data));
			if (data) {
				dispatch(showPackageDispatch());
				// navigate('/bank/list');
				Swal.fire({
					title: 'Package  Updated Successfully!',
					icon: 'success',
					draggable: true,
				});
			}
		} catch (error) {
			console.log('error', error);
			dispatch(
				updateBannerFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message,
				),
			);
		}
	};
export const deletePDispatch = (id, Swal, token) => async (dispatch) => {
	try {
		const config = {
			headers: {
				Accept: 'application/json',
				// Authorization: `Bearer ${token}`,
			},
		};
		dispatch(deleteBankRequest());
		const { data } = await axiosInstance.delete(`/package/${id}`, config);
		console.log('data', data);
		dispatch(deleteBankSuccess(data));
		if (data) {
			dispatch(showPackageDispatch());
			// navigate('/bank/list');
			Swal.fire({
				title: 'Package  Delete Successfully!',
				icon: 'success',
				draggable: true,
			});
		}
	} catch (error) {
		console.log('error', error);
		dispatch(
			deleteBankFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message,
			),
		);
	}
};
export const getMarkupDispatch = () => async (dispatch) => {
	try {
		const config = {
			headers: {
				Accept: 'application/json',
				// Authorization: `Bearer ${token}`,
			},
		};
		dispatch(markupRequest());
		const { data } = await axiosInstance.get(`/markups`, config);
		console.log('data', data);
		dispatch(markupSuccess(data));
	} catch (error) {
		console.log('error', error);
		dispatch(
			markupFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message,
			),
		);
	}
};
export const updateMarkupDispatch =
	(bodyData, id, Swal) => async (dispatch) => {
		try {
			// const config = {
			// 	headers: {
			// 		Accept: 'multipart/form-data',
			// 		// Authorization: `Bearer ${token}`,
			// 	},
			// };
			dispatch(updateBannerRequest());
			const { data } = await axiosInstance.put(
				`/markups/${id}`,
				bodyData,
				config,
			);
			console.log('data', data);
			dispatch(updateBannerSuccess(data));
			if (data) {
				dispatch(getMarkupDispatch());
				// navigate('/bank/list');
				Swal.fire({
					title: 'Markup  Updated Successfully!',
					icon: 'success',
					draggable: true,
				});
			}
		} catch (error) {
			console.log('error', error);
			dispatch(
				updateBannerFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message,
				),
			);
		}
	};
export default GeneralReducer;
